import React from 'react';

import { Block, withConfig } from '../common/Block.jsx';
import { Builder,  EditorContainer } from './Builder.jsx';
import { Link, HoverableLink } from '../common/Button.jsx';
import Layout from '../common/Layout.jsx';
import Name from '../common/Name.jsx';
import Token from '../common/Token.jsx';
import Url from '../common/Url.jsx';
import Utilities from '../common/Utilities.jsx';

function FooterContainer(props) {
    const config = props.config || {};
    let blocks = [];
    const contentConfig = props.contentConfig;
    const hasFooterDocument = contentConfig && contentConfig[props.type];
    if (hasFooterDocument && contentConfig[props.type].blocks) {
        blocks = contentConfig[props.type].blocks;
    }
    let className = `foot--whitelabel foot--whitelabel--${props.type}`;
    if (props.disabled) {
        className += ' disabled';
    }
    let containerProps;
    if (hasFooterDocument && contentConfig[props.type].page) {
        containerProps = { config: contentConfig[props.type].page.config };
    }
    let pageProps;
    if (props.onPageProps) {
        pageProps = props.onPageProps();
    } else {
        pageProps = containerProps;
    }
    let backgroundColor = config.colors && config.colors.footerBackground;
    let copyrightFontSize = 16;
    if (pageProps && pageProps.config) {
        if (pageProps.config.block && pageProps.config.block.backgroundColor) {
            backgroundColor = pageProps.config.block.backgroundColor;
        }
        if (pageProps.config.copyright && pageProps.config.copyright.fontSize && pageProps.config.copyright.fontSize.value) {
            copyrightFontSize = parseFloat(pageProps.config.copyright.fontSize.value);
        }
    }
    let bottomPadding;
    const handleMapStyleConfigProp = (configName, propName, propValue, propUnit) => {
        if (configName == 'copyright') {
            return true;
        }
        switch (propName) {
            case 'paddingBottom':
                if (propValue && propUnit) {
                    bottomPadding = parseFloat(propValue);
                }
                return true;
        }
    }
    const handleBlockProps = (d) => {
        if (!d.type) {
            return;
        }
        const blockProps = { backgroundColor };
        switch (d.type.value) {
            case Name.Block.Footer.SubscribeForm.Container:
                blockProps.builder = props.builder || props.disabled;
                break;
        }
        return blockProps;
    }
    const handleContent = (content, style, contentProps) => {
        if (props.builder) {
            const contentClassName = contentProps.className;
            contentProps.className = 'foot--whitelabel--droparea';
            if (props.dragging) {
                contentProps.className += ' dragging';
            }
            return <div className={contentClassName} style={style}>{content}</div>
        }
        Utilities.copyObject(style, contentProps.style);
        return (
            <div className='foot--content'>
                {content}
            </div>
        );
    }
    return (
        <EditorContainer
            {...props}
            blocks={blocks}
            blockPropsHandler={handleBlockProps}
            builderBlockPropsHandler={Builder.handleBlockProps}
            className={className}
            containerProps={containerProps}
            offsetBottom={(bottomPadding || 0) + (copyrightFontSize < 8 ? 8 : copyrightFontSize)}
            onContainerProps={props.onPageProps}
            onContent={handleContent}
            onMapStyleConfigProp={handleMapStyleConfigProp} />
    );
}

// region ADDRESS (-- DEPRECATED Use `Address` from block/Contact.jsx --)

function AddressComponent(props) {
    let lineItemClassName = 'foot--main__text';
    if (props.simple) {
        lineItemClassName = 'foot--simp__text';
    }
    let includes = {};
    let containerStyle, lineItemHoverProps, lineItemStyle;
    if (props.blockConfig) {
        lineItemClassName = 'foot--main__text';

        if (props.blockConfig.block) {
            containerStyle = {};
            lineItemStyle = {};
            Block.mapStyleConfigProps(lineItemStyle, props.blockConfig.block, (propName, propValue, propUnit) => {
                switch (propName) {
                    case 'direction':
                        containerStyle.flexDirection = props.blockConfig.block.direction;
                        if (containerStyle.flexDirection == 'row') {
                            containerStyle.flexWrap = 'wrap';
                        }
                        return true;
                    case 'lineSpacing':
                        if (propValue == undefined || propUnit == undefined) {
                            return true;
                        }
                        let value = propValue / 2;
                        value = `${value}${propUnit}`;
                        switch (props.blockConfig.block.direction) {
                            case 'column':
                                lineItemStyle.marginBottom = value;
                                lineItemStyle.paddingBottom = value;
                                break;
                            case 'row':
                                lineItemStyle.marginRight = value;
                                lineItemStyle.paddingRight = value;
                                break;
                        }
                        return true;
                    default:
                        if (propName.indexOf('Hover') < 0 || propValue == undefined || propValue == '') {
                            break;
                        }
                        if (!lineItemHoverProps) {
                            lineItemHoverProps = {};
                        }
                        const _propName = propName.replace('Hover', '');
                        lineItemHoverProps[_propName] = propValue;
                        return true;
                }
            });
        }
        if (props.blockConfig.includes) {
            includes = props.blockConfig.includes;
        }
        if (props.blockConfig.layout) {
            if (!containerStyle) {
                containerStyle = {};
            }
            Block.mapStyleConfigProps(containerStyle, props.blockConfig.layout);
        }
    }
    if (props.builder || props.disabled) {
        if (!lineItemStyle) {
            lineItemStyle = {};
        }
        lineItemStyle.pointerEvents = 'none';
    }

    const config = props.config || {};
    const lineItems = [];
    if (config.addressLineOne && config.addressLineOne.length > 0) {
        lineItems.push({ display: config.addressLineOne, type: 'text' });
    }
    if (config.addressLineTwo && config.addressLineTwo.length > 0) {
        lineItems.push({ display: config.addressLineTwo, type: 'text' });
    }
    let location;
    if (config.city && config.city.length > 0) {
        location = config.city;
    }
    if (config.state && config.state.length > 0) {
        if (location) {
            location += `, ${config.state}`;
        } else {
            location = config.state;
        }
    }
    if (config.zip && config.zip.length > 0) {
        if (location) {
            location += ` ${config.zip}`;
        } else {
            location = config.zip;
        }
    }
    if (location && location.length > 0) {
        lineItems.push({ display: location, type: 'text' });
    }
    if (includes.country != false && config.country && config.country.length > 0) {
        lineItems.push({ display: config.country, type: 'text' });
    }
    if (includes.phone != false && config.phone && config.phone.length > 0) {
        lineItems.push({ display: config.phone, link: `tel:${config.phone}`, type: 'link' });
    }
    if (includes.contact != false && config.contact) {
        const link = Url.getLink(props.baseUrl, config.contact.relativeUrl, { sub: props.querySub, layout: props.queryLayout, dataSub: props.queryDataSub }, props.builder);
        lineItems.push({ display: config.contact.title, link: link, type: 'link' });
    }
    const isLegacy = props.type == 'legacy';
    const content = lineItems.map((d, i) => {
        let style = lineItemStyle;
        if (i == lineItems.length - 1) {
            style = {};
            Utilities.copyObject(lineItemStyle, style);
            style.borderRightColor = undefined;
            style.borderRightStyle = undefined;
            style.borderRightWidth = undefined;
            style.marginBottom = 0;
            style.marginRight = 0;
            style.paddingBottom = 0;
            style.paddingRight = 0;
        }
        switch (d.type) {
            case 'link':
                if (isLegacy) {
                    return <a key={i} className={lineItemClassName} href={d.link} style={style}>{d.display}</a>
                }
                const linkProps = {
                    className: lineItemClassName,
                    href: d.link,
                    style: style
                }
                let LinkComponent = Link;
                if (lineItemHoverProps != undefined) {
                    LinkComponent = HoverableLink;
                    linkProps.hoverProps = lineItemHoverProps;
                }
                return (
                    <div key={i} className="foot--main__text--wrap">
                        <LinkComponent {...linkProps}>{d.display}</LinkComponent>
                    </div>
                );
            case 'text':
                return <div key={i} className={lineItemClassName} style={style}>{d.display}</div>
        }
    });
    if (isLegacy) {
        return <React.Fragment>{content}</React.Fragment>;
    }
    const isRowDirection = containerStyle && containerStyle.flexDirection == 'row';
    return (
        <div className="foot--address" style={containerStyle}>
            {
                isRowDirection &&
                containerStyle.textAlign != 'left' &&
                <span style={{ flex: 1 }} />
            }
            {content}
            {
                isRowDirection &&
                containerStyle.textAlign != 'right' &&
                <span style={{ flex: 1 }} />
            }
        </div>
    );
}
const Address = { Component: AddressComponent };

// region COPYRIGHT

function Copyright(props) {
    const style = {};
    if (props.type != 'legacy') {
        let pageProps;
        if (props.onPageProps) {
            pageProps = props.onPageProps();
        } else {
            const contentConfig = props.contentConfig;
            if (contentConfig && contentConfig[props.type] && contentConfig[props.type].page) {
                pageProps = { config: contentConfig[props.type].page.config }
            }
        }
        style.fontSize = '16px';
        if (pageProps && pageProps.config) {
            if (pageProps.config.copyright) {
                Block.mapStyleConfigProps(style, pageProps.config.copyright, (propName, propValue, propUnit) => {
                    switch (propName) {
                        case 'fontSize':
                            let _value = parseFloat(propValue);
                            if (_value < 8) {
                                _value = 8;
                            }
                            if (_value && propUnit) {
                                style[propName] = `${_value}${propUnit}`;
                            }
                            return true;
                    }
                });
            }
            if (pageProps.config.layout) {
                Block.mapStyleConfigProps(style, pageProps.config.layout, (propName) => {
                    switch (propName) {
                        case 'paddingBottom':
                        case 'paddingLeft':
                        case 'paddingRight':
                            return false;
                        default:
                            return true;
                    }
                });
            }
            if (pageProps.config.block) {
                style.backgroundColor = pageProps.config.block.backgroundColor;
            }
        }
    }

    let className = `foot--whitelabel--copyright foot--whitelabel--copyright--${props.type}`;
    if (props.builder || props.disabled) {
        className += ' builder';
        style.pointerEvents = 'none';
    }
    let display = 'art websites';
    let link = 'https://artcloud.com/art-websites';
    if (props.config) {
        let hash = 0;
        if (props.config.subdomain) {
            let chr;
            for (let i = 0; i < props.config.subdomain.length; i++) {
                chr = props.config.subdomain.charCodeAt(i);
                hash = ((hash << 5) - hash) + chr;
                hash |= 0; // Convert to 32bit integer
            }
        }
        hash = hash % 2;
        switch (props.config.userType) {
            case 1:
                display = 'Artist';
                if (hash == 0) {
                    display += ' Websites';
                    link = 'https://artcloud.com/artist-websites';
                } else {
                    display += ' Studio Management Software';
                    link = 'https://artcloud.com/manager-for-artists';
                }
                break;
            default:
                display = 'Art Gallery';
                if (hash == 0) {
                    display += ' Websites';
                    link = 'https://artcloud.com/art-websites-for-galleries';
                } else {
                    display += ' Software';
                    link = 'https://artcloud.com/manager-for-galleries';
                }
                break;
        }

        link = `${link}?utm_source=${props.config.subdomain}`;
    }
    return (
        <span className={className} style={style}>
            Copyright © {(new Date()).getUTCFullYear()}, <a href={link} style={{ color: 'inherit' }} target="_blank" rel="noreferrer">{display} by ArtCloud</a>
        </span>
    );
}

// region CUSTOM CONTENT

function CustomContent(props) {
    const config = props.config || {};
    if (!config.footer || config.footer.length == 0) {
        return null;
    }
    let style;
    if (props.builder) {
        style = { pointerEvents: 'none' };
    }
    let content = <div className={props.className} dangerouslySetInnerHTML={{ __html: config.footer }} style={style} />
    if (props.appendNewline) {
        content = (
            <React.Fragment>
                {content}
                <br />
            </React.Fragment>
        );
    }
    return content;
}

// region QUICK LINKS

function QuickLink(props) {
    let target;
    let url;
    if (props.data.type && props.data.type.value == 6) {
        // External Link
        target = '_blank';
        url = props.data.relativeUrl;
    } else {
        url = Url.getLink(props.baseUrl, props.data.relativeUrl, { sub: props.sub, layout: props.layout, dataSub: props.dataSub }, props.builder);
    }
    let className = 'foot--main__anch';
    if (props.isLegacy) {
        return <a className={className} href={url} style={props.style} target={target}>{props.data.title}</a>
    }
    let design;
    if (props.design) {
        design = Token.parseTokenizedString(props.design, () => props.data.title);
        className += ' richText';
    } else {
        design = `<span>${props.data.title}</span>`;
    }
    let hoverProps;
    let LinkComponent = Link;
    if (props.hoverProps != undefined) {
        LinkComponent = HoverableLink;
        if (props.hoverProps.color) {
            hoverProps = { design: Utilities.injectStyleIntoString(design, `color:${props.hoverProps.color};`) };
        } else {
            hoverProps = { ...props.hoverProps };
        }
    }
    return (
        <div className="foot--main__anch--wrap" style={props.style}>
            <LinkComponent
                className={className}
                contentClassName="p"
                design={design}
                hoverProps={hoverProps}
                href={url}
                style={props.linkStyle}
                target={target} />
        </div>
    );
}

function QuickLinksComponent(props) {
    const layoutStyles = Block.mapLayoutStyleConfigPropsWithPageKit({}, props);
    let lineItemStyle, linkDesign, linkHoverProps, linkStyle;
    if (props.blockConfig && props.blockConfig.block) {
        lineItemStyle = {};
        Block.mapStyleConfigProps(lineItemStyle, props.blockConfig.block, (propName, propValue, propUnit) => {
            switch (propName) {
                case 'colorHover':
                    if (propValue) {
                        if (!linkHoverProps) {
                            linkHoverProps = {};
                        }
                        linkHoverProps.color = propValue;
                    }
                    return true;
                case 'design':
                    linkDesign = Layout.editorTextInternals(propValue);
                    return true;
                case 'direction':
                    layoutStyles.style.flexDirection = props.blockConfig.block.direction;
                    return true;
                case 'lineSpacing':
                    if (propValue == undefined || propUnit == undefined) {
                        return true;
                    }
                    let value = propValue / 2;
                    value = `${value}${propUnit}`;
                    switch (props.blockConfig.block.direction) {
                        case 'column':
                            lineItemStyle.marginBottom = value;
                            lineItemStyle.paddingBottom = value;
                            break;
                        case 'row':
                            lineItemStyle.marginRight = value;
                            lineItemStyle.paddingRight = value;
                            break;
                    }
                    return true;
                case 'color':
                case 'opacity':
                    if (!linkStyle) {
                        linkStyle = {};
                    }
                    linkStyle[propName] = propValue;
                    return true;
                default:
                    if (propName.indexOf('Hover') < 0 || propValue == undefined || propValue == '') {
                        break;
                    }
                    if (!linkHoverProps) {
                        linkHoverProps = {};
                    }
                    const _propName = propName.replace('Hover', '');
                    linkHoverProps[_propName] = propValue;
                    return true;
            }
        });
    }
    if (props.builder || props.disabled) {
        if (!lineItemStyle) {
            lineItemStyle = {};
        }
        lineItemStyle.pointerEvents = 'none';
    }
    const data = Layout.navPages(props.config, 5, true);
    const isLegacy = props.type == 'legacy';
    let content = data.map((d, i) => {
        let style = lineItemStyle;
        if (i == data.length - 1) {
            style = {};
            Utilities.copyObject(lineItemStyle, style);
            style.borderRightColor = undefined;
            style.borderRightStyle = undefined;
            style.borderRightWidth = undefined;
            style.marginBottom = 0;
            style.marginRight = 0;
            style.paddingBottom = 0;
            style.paddingRight = 0;
        }
        return (
            <QuickLink
                key={i}
                baseUrl={props.baseUrl}
                builder={props.builder}
                data={d}
                dataSub={props.queryDataSub}
                design={linkDesign}
                hoverProps={linkHoverProps}
                isLegacy={isLegacy}
                layout={props.queryLayout}
                linkStyle={linkStyle}
                style={style}
                sub={props.querySub} />
        );
    });
    const isRowDirection = layoutStyles.style.flexDirection == 'row';
    if (isRowDirection) {
        layoutStyles.style.alignItems = 'center';
    }
    let className = 'foot--main__anch__cont';
    if (linkDesign) {
        className += ' foot--main__anch__cont2';
    }
    const textAlign = layoutStyles.style.textAlign || 'left';
    content = (
        <div className={className} style={layoutStyles.style}>
            {
                isRowDirection &&
                textAlign != 'left' &&
                <span style={{ flex: 1 }} />
            }
            {content}
            {
                isRowDirection &&
                textAlign != 'right' &&
                <span style={{ flex: 1 }} />
            }
        </div>
    );
    if (layoutStyles.containerStyle) {
        if (props.inLayout) {
            layoutStyles.containerStyle.width = '100%';
        }
        content = <div className="foot--cont" style={layoutStyles.containerStyle}>{content}</div>
    }
    return content;
}
const QuickLinks = { Component: QuickLinksComponent };

// region SOCIAL (-- DEPRECATED Use block/Social.jsx --)

function SocialLink(props) {
    const linkProps = {
        'aria-label': props.name,
        className: 'social__anch',
        href: props.url,
        rel: 'noreferrer',
        style: props.style,
        target: '_blank'
    }
    let LinkComponent = Link;
    if (props.hoverProps != undefined) {
        LinkComponent = HoverableLink;
        linkProps.hoverProps = props.hoverProps;
    }
    return <LinkComponent {...linkProps}><span className={`i ${props.icon}`}></span></LinkComponent>
}

function _SocialComponent(props) {
    let containerStyle, itemHoverProps, itemStyle;
    if (props.blockConfig) {
        if (props.blockConfig.block) {
            itemStyle = {};
            Block.mapStyleConfigProps(itemStyle, props.blockConfig.block, (propName, propValue, propUnit) => {
                switch (propName) {
                    case 'lineSpacing':
                        if (propValue == undefined || propUnit == undefined) {
                            return true;
                        }
                        let value = propValue / 2;
                        value = `${value}${propUnit}`;
                        itemStyle.marginRight = value;
                        itemStyle.paddingRight = value;
                        return true;
                    default:
                        if (propName.indexOf('Hover') < 0 || propValue == undefined || propValue == '') {
                            break;
                        }
                        if (!itemHoverProps) {
                            itemHoverProps = {};
                        }
                        const _propName = propName.replace('Hover', '');
                        itemHoverProps[_propName] = propValue;
                        return true;
                }
            });
        }
        if (props.blockConfig.layout) {
            containerStyle = {};
            Block.mapStyleConfigProps(containerStyle, props.blockConfig.layout);
        }
    }
    if (props.builder || props.disabled) {
        if (!itemStyle) {
            itemStyle = {};
        }
        itemStyle.pointerEvents = 'none';
    }
    const config = props.config || {};
    const links = [];
    if (config.artCloudUrl && config.artCloudUrl.length > 0) {
        links.push({ icon: 'i-ac-social', url: config.artCloudUrl, name: 'ArtCloud' })
    }
    if (config.pinterestUrl && config.pinterestUrl.length > 0) {
        links.push({ icon: "i-pint", url: config.pinterestUrl, name: 'Pinterest' });
    }
    if (config.twitterUrl && config.twitterUrl.length > 0) {
        links.push({ icon: "i-twit", url: config.twitterUrl, name: 'Twitter' });
    }
    if (config.instagramUrl && config.instagramUrl.length > 0) {
        links.push({ icon: "i-inst", url: config.instagramUrl, name: 'Instagram' });
    }
    if (config.facebookUrl && config.facebookUrl.length > 0) {
        links.push({ icon: "i-fcbk", url: config.facebookUrl, name: 'Facebook' });
    }
    if (config.artsyUrl && config.artsyUrl.length > 0) {
        links.push({ icon: "i-artsy", url: config.artsyUrl, name: 'Artsy' });
    }
    if (config.artnetUrl && config.artnetUrl.length > 0) {
        links.push({ icon: "i-artnet", url: config.artnetUrl, name: 'ArtNet' });
    }
    if (config.firstDibsUrl && config.firstDibsUrl.length > 0) {
        links.push({ icon: "i-st", url: config.firstDibsUrl, name: '1stDibs' });
    }
    if (config.houzzUrl && config.houzzUrl.length > 0) {
        links.push({ icon: "i-houzz", url: config.houzzUrl, name: 'Houzz' });
    }
    if (config.youTubeUrl && config.youTubeUrl.length > 0) {
        links.push({ icon: "i-youtube", url: config.youTubeUrl, name: 'YouTube' });
    }
    if (links.length == 0) {
        return null;
    }
    if (props.type == 'legacy') {
        return <React.Fragment>{links.map((d, i) => <SocialLink key={i} builder={props.builder} icon={d.icon} url={d.url} />)}</React.Fragment>
    }
    const content = links.map((d, i) => {
        let style = itemStyle;
        if (i == links.length - 1) {
            style = {};
            Utilities.copyObject(itemStyle, style);
            style.borderRightColor = undefined;
            style.borderRightStyle = undefined;
            style.borderRightWidth = undefined;
            style.marginBottom = 0;
            style.marginRight = 0;
            style.paddingBottom = 0;
            style.paddingRight = 0;
        }
        return (
            <SocialLink
                key={i}
                builder={props.builder}
                hoverProps={itemHoverProps}
                icon={d.icon}
                name={d.name}
                style={style}
                url={d.url} />
        );
    });
    return <div className="social__cont" style={containerStyle}>{content}</div>
}
const SocialComponent = withConfig(_SocialComponent);
const Social = { Component: SocialComponent };

export {
    Copyright,
    CustomContent,
    FooterContainer,
    QuickLinks,

    // DEPRECATED
    Address,
    Social
};
